import { CellPlugin } from '@react-page/editor';
import PikeShoppingCart, { TITLE, SUBTITLE, NAME_LABEL, ACCOUNT_LABEL, TAX_YEAR_LABEL,TAX_TYPE_LABEL, ADDRESS_LABEL,
    TOTAL_DUE_LABEL,DUE_DATE_LABEL,ACTIONS_LABEL,HEADER_BACKGROUND_COLOR,HEADER_PADDING,MARGIN,PADDING,  CART_BUTTON_BACKGROUND_COLOR, CART_BUTTON_FONT_COLOR, CART_BUTTON_FONT_SIZE, 
    CART_BUTTON_FONT_STYLE, CART_BUTTON_FONT_WEIGHT, CART_BUTTON_BORDER_COLOR, CART_ICON_COLOR
} from './components/PikeShoppingCart';

type Data = {
    title: string,
    subTitle: string,
    name: string,
    account: string,
    taxYear: string,
    taxType: string,
    address: string,
    totalDue: string,
    dueDate: string,
    actions: string,
    headerBackgroundColor: string,
    headerPadding: string,
    margin: string,
    padding: string,
    cartButtonBackgroundColor: string,
    cartButtonFontColor: string,
    cartButtonFontSize: string,
    cartButtonFontStyle: string,
    cartButtonFontWeight: string,
    cartButtonBorderColor: string,
    cartIconColor: string
}

const PikeShoppingCartPlugin: CellPlugin<Data> = {
    Renderer: ({ data }) => (
        <PikeShoppingCart
            title = {data.title}
            subTitle={data.subTitle}
            nameLabel={data.name}
            accountLabel={data.account}
            taxYearLabel={data.taxYear}
            taxTypeLabel={data.taxType}
            addressLabel={data.address}
            totalDueLabel={data.totalDue}
            dueDateLabel={data.dueDate}
            actionsLabel={data.actions}
            margin={data.margin}
            padding={data.padding}
            cartButtonBackgroundColor={data.cartButtonBackgroundColor}
            cartButtonFontColor={data.cartButtonFontColor}
            cartButtonFontSize={data.cartButtonFontSize}
            cartButtonFontStyle={data.cartButtonFontStyle}
            cartButtonFontWeight={data.cartButtonFontWeight}
            cartButtonBorderColor={data.cartButtonBorderColor}
            headerBackgroundColor={data.headerBackgroundColor}
            headerPadding={data.headerPadding}
            cartIconColor={data.cartIconColor}
        />
    ),
    id: 'pikeShoppingCartPlugin',
    title: 'Pike Shopping Cart ',
    description: 'Adds items to shopping cart',
    version: 1,
    controls: [
        {
            title: 'Labels',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        title: {
                            type: 'string',
                            default: TITLE,
                        },
                        subTitle: {
                            type: 'string',
                            default: SUBTITLE,
                        },
                        name: {
                            type: 'string',
                            default: NAME_LABEL,
                        },
                        account: {
                            type: 'string',
                            default: ACCOUNT_LABEL,
                        },
                        taxYear: {
                            type: 'string',
                            default: TAX_YEAR_LABEL,
                        },
                        taxType: {
                            type: 'string',
                            default: TAX_TYPE_LABEL,
                        },
                        address: {
                            type: 'string',
                            default: ADDRESS_LABEL,
                        },
                        totalDue: {
                            type: 'string',
                            default: TOTAL_DUE_LABEL,
                        },
                        dueDate: {
                            type: 'string',
                            default: DUE_DATE_LABEL,
                        },
                        actions: {
                            type: 'string',
                            default: ACTIONS_LABEL,
                        }
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Styles',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        margin: {
                            type: 'string',
                            default: MARGIN,
                        },
                        padding: {
                            type: 'string',
                            default: PADDING,
                        },
                        headerBackgroundColor: {
                            type: 'string',
                            default: HEADER_BACKGROUND_COLOR,
                        },
                        headerPadding: {
                            type: 'string',
                            default: HEADER_PADDING,
                        },
                        cartButtonBackgroundColor: {
                            type: 'string',
                            default: CART_BUTTON_BACKGROUND_COLOR,
                        },
                        cartButtonFontColor: {
                            type: 'string',
                            default: CART_BUTTON_FONT_COLOR,
                        },
                        cartButtonFontSize: {
                            type: 'string',
                            default: CART_BUTTON_FONT_SIZE,
                        },
                        cartButtonFontStyle: {
                            type: 'string',
                            default: CART_BUTTON_FONT_STYLE,
                        },
                        cartButtonFontWeight: {
                            type: 'string',
                            default: CART_BUTTON_FONT_WEIGHT,
                        },
                        cartButtonBorderColor: {
                            type: 'string',
                            default: CART_BUTTON_BORDER_COLOR,
                        },
                        cartIconColor: {
                            type: 'string',
                            default: CART_ICON_COLOR
                        }
                        
                    },
                    required: [],
                },
            },
        },
    ],
};

export default PikeShoppingCartPlugin;